import * as React from 'react';
import { IgcQueryBuilderHeaderComponent as Component } from 'igniteui-webcomponents-grids/grids/index.js';
import { createComponent } from '../react-props.js';

/**
 * @class
 */
export const IgrQueryBuilderHeader = /* @__PURE__ */ createComponent({
  tagName: 'igc-query-builder-header',
  displayName: 'IgrQueryBuilderHeader',
  elementClass: Component,
  react: React,
  moveBackOnDelete: true,
});

export type IgrQueryBuilderHeader = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrQueryBuilderHeaderModule = Component;
